export default {
    common: {
        title: 'ผลคาบเรียน',
        selfTitle: 'ผลการเรียนด้วยตนเอง',
        taskTitle: 'ผลการบ้าน',
    },
    studentResult: {
        subtitle: 'มาดูสิ่งที่เรียนไปกันเถอะ',
        totalActivities: 'ทำกิจกรรมไปทั้งหมด { count } กิจกรรม!',
    },
    teacherResult: {
        sessionInfo: 'ข้อมูลคาบเรียน',
        sessionInfoItem: {
            title: 'ข้อมูลพื้นฐานของคาบเรียน',
            date: 'วันที่',
            duration: 'ระยะเวลาที่ใช้',
            studentCount: 'จำนวนผู้เข้าร่วม',
            curriculum: 'หน่วยย่อย',
        },
        noModules: 'ยังไม่มีกิจกรรมที่ดำเนินการ',
        showMvp: 'ประกาศ MVP',
    },
};
